import { XCircleIcon } from "lucide-react";

import { Centered } from "@/components/ui/container";
import { Text } from "@/components/ui/text";

export function ErrorPage({ error }: { error: { message?: string } }) {
  return (
    <Centered className="bg-muted/50">
      <div className="flex flex-col items-center gap-2">
        <XCircleIcon className="size-8 text-destructive" />
        <Text muted size="lg">
          {error.message}
        </Text>
      </div>
    </Centered>
  );
}
